(function ($) {
    $(document).ready(function () {

        const $appearAfter = $('h1, h2, h3, h4, div, p, a, img:not(.svg), ul, li');
        appearOnScroll();
        $(window).scroll(appearOnScroll);

        /**
         * Return true if the element is into the viewport
         * @param $elem
         * @returns {boolean}
         */
        function isIntoView($elem) {
            const docViewTop = $(window).scrollTop();
            const docViewBottom = docViewTop + $(window).height();
            const elemTop = $elem.offset().top;
            const elemBottom = $elem.offset().top + $elem.innerHeight();
            return ((elemTop <= docViewBottom && elemTop >= docViewTop) ||
                (elemBottom <= docViewBottom && elemBottom >= docViewTop) ||
                (elemTop <= docViewTop && elemBottom >= docViewBottom));
        }

        /**
         * Display all the elemens in $appearAfter if there are into the viewport
         */
        function appearOnScroll() {
            $appearAfter.each(function () {
                const $el = $(this);
                if (isIntoView($el)) {
                    $el.animate({opacity: 1}, 750);
                }
            });
        }

    });
})(jQuery);
